var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text-svgrepo-com 1",
    clipPath: "url(#clip0_716_25184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33325 14.1669H6.66659V15.1669H9.33325V14.1669ZM1.83325 9.33353V6.66686H0.833252V9.33353H1.83325ZM14.1666 9.04213V9.33353H15.1666V9.04213H14.1666ZM9.92739 3.07428L12.5666 5.44954L13.2355 4.70624L10.5964 2.33098L9.92739 3.07428ZM15.1666 9.04213C15.1666 7.91653 15.1767 7.20386 14.8927 6.56618L13.9792 6.973C14.1565 7.3712 14.1666 7.8282 14.1666 9.04213H15.1666ZM12.5666 5.44954C13.4689 6.2616 13.8019 6.57486 13.9792 6.973L14.8927 6.56618C14.6087 5.92847 14.0722 5.45922 13.2355 4.70624L12.5666 5.44954ZM6.68645 1.83353C7.74099 1.83353 8.13892 1.84125 8.49359 1.97735L8.85185 1.04373C8.28399 0.82581 7.66525 0.83353 6.68645 0.83353V1.83353ZM10.5964 2.33098C9.87239 1.67938 9.41972 1.26162 8.85185 1.04373L8.49359 1.97735C8.84839 2.11348 9.14759 2.37244 9.92739 3.07428L10.5964 2.33098ZM6.66659 14.1669C5.39537 14.1669 4.49226 14.1658 3.80715 14.0737C3.13643 13.9835 2.74999 13.8144 2.46785 13.5323L1.76075 14.2394C2.25966 14.7383 2.89229 14.9597 3.67391 15.0648C4.44113 15.1679 5.42364 15.1669 6.66659 15.1669V14.1669ZM0.833252 9.33353C0.833252 10.5765 0.832192 11.559 0.935339 12.3262C1.04043 13.1078 1.26184 13.7405 1.76075 14.2394L2.46785 13.5323C2.18571 13.2501 2.0166 12.8637 1.92643 12.193C1.83431 11.5079 1.83325 10.6047 1.83325 9.33353H0.833252ZM9.33325 15.1669C10.5762 15.1669 11.5587 15.1679 12.3259 15.0648C13.1075 14.9597 13.7402 14.7383 14.2391 14.2394L13.532 13.5323C13.2499 13.8144 12.8634 13.9835 12.1927 14.0737C11.5076 14.1658 10.6045 14.1669 9.33325 14.1669V15.1669ZM14.1666 9.33353C14.1666 10.6047 14.1655 11.5079 14.0734 12.193C13.9833 12.8637 13.8141 13.2501 13.532 13.5323L14.2391 14.2394C14.738 13.7405 14.9594 13.1078 15.0645 12.3262C15.1677 11.559 15.1666 10.5765 15.1666 9.33353H14.1666ZM1.83325 6.66686C1.83325 5.39565 1.83431 4.49254 1.92643 3.80743C2.0166 3.1367 2.18571 2.75027 2.46785 2.46813L1.76075 1.76102C1.26184 2.25994 1.04043 2.89256 0.935339 3.67418C0.832192 4.44141 0.833252 5.42392 0.833252 6.66686H1.83325ZM6.68645 0.83353C5.43684 0.83353 4.44953 0.832477 3.67917 0.935577C2.8948 1.04056 2.26005 1.26173 1.76075 1.76102L2.46785 2.46813C2.74961 2.18638 3.13723 2.01703 3.81182 1.92674C4.50042 1.83458 5.40866 1.83353 6.68645 1.83353V0.83353Z",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 9.6665H9.33333",
    stroke: "#535353",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4 12H7.66667",
    stroke: "#535353",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.66675 1.6665V3.33317C8.66675 4.90452 8.66675 5.69019 9.15488 6.17835C9.64308 6.6665 10.4287 6.6665 12.0001 6.6665H14.6667",
    stroke: "#535353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_716_25184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.f77f1d3ce109920a3b7b1b1dc5005afa.svg";
export { ForwardRef as ReactComponent };